import VHtmlPanelCompents from './VHtmlPanel.vue'

const VHtmlPanel={
    install:function (Vue) {
        Vue.component('VHtmlPanel',VHtmlPanelCompents)
    }
}
export default VHtmlPanel
